import { Suspense, lazy } from 'react';
import PageLoader from 'components/PageLoader';
import { AppRouteComponentProps } from 'components/AppRoutes';

const PDPComponent = lazy(() => import('./PDP.component'));

export default function PersonalDevelopmentPlan(props: AppRouteComponentProps) {
  return (
    <Suspense fallback={<PageLoader open />}>
      <PDPComponent {...props} />
    </Suspense>
  );
}
